<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" :disabled="showBigButtons"  @click="cancel()">{{ (showBigButtons) ? "" : t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ props.title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="confirm()" :disabled="showBigButtons"  :strong="true">{{ (showBigButtons) ? "" : t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>

     <div v-show="showBigButtons" id="header">
      <div class="cancel_done_container">
        <ion-grid>
          <div v-show="showScrollButtons">
          <ion-row >
            <ion-col size="6">
              <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
            </ion-col>
            <ion-col size="3">
              <ion-button class="general-big-button scroll-button-color scroll-button-width" @click="scrollPage('up')">{{ t("Scroll Up") }}</ion-button>      
            </ion-col>
            <ion-col size="3">
              <ion-button class="general-big-button scroll-button-color scroll-button-width" @click="scrollPage('down')">{{ t("Scroll Down") }}</ion-button>
            </ion-col>
          </ion-row>
          </div>
          <div v-show="!showScrollButtons">

          <ion-row>
            <ion-col size="12">
              <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
            </ion-col>
          </ion-row>
          </div>
        </ion-grid>
      </div>  
    </div>  

  </ion-header>

  <ion-content>

    <div id="page">
      <div v-for="(item,i) in props.displayArray" :key="item.id">
        <ion-button :id="item.code" class="general-big-button action-button-color action-button-width" @click="buttonClicked(item.data)">
          <ion-label>
            <h1>{{ item.text }}</h1>
            {{ item.current }}
          </ion-label>
          </ion-button>
      </div>
    </div>
  </ion-content>
</template>

<script  setup>

// https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport

  import {
    IonGrid,IonCol,IonRow,
    IonLabel,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    modalController,
  } from '@ionic/vue';

  import { defineComponent, ref , onMounted, watch } from 'vue';
  import { t } from '@/composables/translateText.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { scrollElement } from '@/composables/screenSize'

  const props = defineProps({
    title : {
      type : String,
      default : "TITLE"
    },
    displayArray : {
      type : Array,
      default : []
    },
    forceBigButtons : {
      type : Boolean,
      default : false
    }
	})

  // get button ids so we can scroll by elelment id
  var idArray = []
  for (var i=0; i < props.displayArray.length; i++)
    idArray.push(props.displayArray[i].code)
  //console.log("id array ",idArray)
  var currentScrollIndex = 0
  var scrollIncrement = 1

  //console.log("values",props.displayArray)

  const selectedValue = ref(props.initialValue)

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(props.forceBigButtons || whichMenu == "buttons" || connectionStore.getShowBigButtons)
  const scalePercentage = connectionStore.getToolbarScalePercentage

  const baseButtonHeight = 50
  const useButtonHeight = (showBigButtons.value) ? Math.floor( baseButtonHeight * scalePercentage / 100.0) :
                baseButtonHeight

  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const showScrollButtons = ref(true)

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    buildStyles()
  })

  onMounted(() => {
    var element = document.getElementById("page")
    if (element != null)
      element.style.setProperty("--done_button_size", useButtonHeight + "px");
    element = document.getElementById("header")
    if (element != null)
      element.style.setProperty("--done_button_size", useButtonHeight + "px");
    buildStyles()
  })

  function buildStyles() {

    const modalHeight = (window.innerHeight || document.documentElement.clientHeight)
    const headingHeight = (showBigButtons.value) ? (useButtonHeight + 50) : 0
    const spaceForButtons = modalHeight - headingHeight
    //console.log("spaceforbuttons",spaceForButtons)

    // if room for all buttons, don't display scroll buttons
    showScrollButtons.value = spaceForButtons < (useButtonHeight + 8) * props.displayArray.length
    scrollIncrement = Math.floor(spaceForButtons / (useButtonHeight + 8) )
    if (scrollIncrement == 0)
      scrollIncrement = 1
    //console.log("Scroll Increment",scrollIncrement)
  }

  function scrollPage(direction) {
    if (direction == "up") {
      if (currentScrollIndex > 0)
        currentScrollIndex -= scrollIncrement;
      if (currentScrollIndex < 0)
        currentScrollIndex = 0
    }
    else {
      if (currentScrollIndex < idArray.length -1)
        currentScrollIndex += scrollIncrement
      if (currentScrollIndex > idArray.length -1)
        currentScrollIndex = idArray.length -1
    }
    const id = idArray[currentScrollIndex]
    const element = document.getElementById(id)
    //console.log("Scroll to Element",element)
    if (element != null)
      element.scrollIntoView({ behavior: "smooth" })
    //scrollElement("page",direction)
  }

  function isElementInViewport (el) {

    var rect = el.getBoundingClientRect();

    //console.log("RECTs",rect,document.documentElement.clientHeight,window.innerHeight)
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  function buttonClicked(data) {
    //console.log("on click",data)
    modalController.dismiss(data.index, 'selected');

  }

  function cancel() {
    modalController.dismiss(null, 'cancel');
  }

  function confirm() {
    var result = { selected : null}

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

</script>

<style scoped>

#page {
  --done_button_size : 50px;
}

#header {
  --done_button_size : 50px;
}

.button_class {
  height : var(--done_button_size);
  width : 23%;
  margin-left : 1%;
  margin-right : 1%;
  background-color: #F5D8B1;
}

.choice_button_class {
  height : var(--done_button_size);
  width : 50%;
  margin-left : 24%;
  margin-right : 24%;
  background-color: #F5D8B1;
}

.title_text {
  background-color: #0d6efd;
  text-align: center;
  font-size: 24px;
}

.done-button-width {
  width : 100%;
}
.scroll-button-width {
  width : 100%;
}

.action-button-color {
  --background: teal;       /* Teal background */
}
.action-button-width {
  width : 100%;
}

.action-button-color:hover {
  --background : #329999;
}

</style>
